// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

/**
 * 1. Admins of the team can edit any other member of the team
 * 2. Non-admins can edit themselves
 */
export function memberDelete(params: { member_id: number }) {
  return http<unknown>({
    url: "/api/v1/members/{member_id}/",
    method: "delete",
    params,
    pathParamNames: ["member_id"],
  })
}
